<template>
     <div class="footerBox">
      <div class="footerList">
        <div class="footerLeft">
          <!-- <img :src="logoW" /> -->
          <div class="footerLeftTitle">联系我们</div>
          <div class="footerContent">
            <div class="footerText">
              <img :src="phone" />
              热线电话：400-022-7978
            </div>
            <div class="footerText">
              <img :src="fax" />
              传真号码：022-58820007
            </div>
            <div class="footerText">
              <img :src="place" />
              公司地址：天津市和平区南市街道多伦道15号
            </div>
            <div class="footerText" style="text-align: center">
              合生财富广场2号楼2101室
            </div>
          </div>
        </div>
        <div class="footerRight">
          <div class="footerRightTitle" @click="goAboutUs">关于展华</div>
          <div class="footerContent">
            <div class="footerText"  @click="goAboutUs" >公司简介</div>
            <div class="footerText" @click="goRecruiment">招贤纳士</div>
          </div>
        </div>
        <div class="footerRight">
          <div class="footerRightTitle" @click="goProductCenter" >智慧医疗产品体系</div>
          <div class="footerContent">
            <div class="footerText"  @click="goMedical" >智慧医疗</div>
            <div class="footerText"  @click="goOperaing" >智慧运营管理</div>
            <div class="footerText"  @click="goService" >智慧服务</div>
            <div class="footerText"  @click="goInter" >智慧互联</div>
          </div>
        </div>
        <div class="footerRight">
          <div class="footerRightTitle">快速链接</div>
          <div class="footerContent">
            <div class="footerText" @click="goMedical">医院管理信息系统（HIS）</div>
            <div class="footerText" @click="goOperaing">展华HRP系统</div>
            <div class="footerText" @click="goInter">集成平台</div>
            <div class="footerText" @click="goService" >智慧门诊</div>
            <div class="footerText" @click="goInter">区域医院信息系统</div>
          </div>
        </div>
      </div>
      <div class="footerLine"></div>
      <div class="record">
       Copyright 1998 - 2021 Zhanhuach. All Rights Reserved  津公网安备 12010102000603号     津ICP备20006216号-2
      </div>
    </div>
</template>
<script>
import logoW from "../../src/assets/logoW.png"
import phone from "../../src/assets/phone.png"
import place from "../../src/assets/place.png"
import fax from "../../src/assets/fax.png"

export default {
      name: "footer",
   data(){

       return{
logoW:logoW,
phone:phone,
place:place,
fax:fax,
       };
       
   },
 methods: {
     goHome() {
      this.$router.push({ path: "/" });
    },
    goProductCenter() {
      this.$router.push({ path: "productCenter" });
    },
    goAboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    goSupandSer() {
      this.$router.push({ path: "SupandSer" });
    },
    goRecruiment() {
      this.$router.push({ path: "recruiment" });
    },
    goMedical() {
      this.$router.push({ path: "medical" });
    },
    goService() {
      this.$router.push({ path: "service" });
    },
    goOperaing() {
      this.$router.push({ path: "operaing" });
    },
    goInter() {
      this.$router.push({ path: "inter" });
    },
  },

}
</script>

<style>

.footerBox {
  background: #050f23;
  height: 440px;
  padding-top: 83px;
}
.footerList {
  display: flex;
  margin: 0 auto;
  justify-content: space-around;
}
.footerRightTitle {
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  cursor: pointer;
}
.footerLeftTitle {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 27px;
}
.footerContent {
  font-family: PingFangSC-Light;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 200;
}
.footerText {
  margin-top: 30px;
}
.footerRight .footerText {
  margin-top: 30px;
  cursor: pointer;
}
.footerLine {
  margin-top: 30px;
  width: 100%;
  opacity: 0.21;
  border-bottom: 1px solid #ffffff;
  margin-bottom: 30px;
}
.record {
  text-align: center;
  opacity: 0.72;
  font-family: PingFangSC-Light;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 200;
}
.footerRight{
    margin-top: 19px;
}
</style>


// WEBPACK FOOTER //
// src/layout/root.vue